const a = {
  code: "ar",
  facebook: "ar_AR",
  label: "عربى",
  loadingText: "جار التحميل...",
  dir: "rtl",
  translations: {
    ar: "العربية",
    de: "الألمانية",
    en: "الإنجليزية",
    es: "الإسبانية",
    fr: "الفرنسية",
    he: "العبرية",
    hi: "الهندية",
    id: "الإندونيسية",
    it: "الإبطالية",
    ja: "اليابانية",
    km: "الخمير",
    ko: "الكورية",
    lo: "اللاوسية",
    ms: "الملايو",
    nl: "الهولندية",
    pt: "البرتغالية",
    ru: "الروسية",
    th: "التايلاندية",
    tl: "الفلبينية",
    tr: "التركية",
    vi: "الفيتنامية",
    "zh-CN": "الصينية (المبسيطة)",
    "zh-TW": "الصينية (التقليدية)"
  }
};
export {
  a as arabic
};
